import Label from '@/core/components/Label/Label';

export default Label;
